import decode from 'jwt-decode';
import { Logger } from '../utils';
export class TokenService {
    constructor(tokenKey) {
        this.tokenKey = tokenKey;
        this.log = new Logger('token');
    }
    getToken() {
        try {
            const jwt = localStorage.getItem(this.tokenKey) || '';
            // remove quotes that angular app adds, this can be removed
            // when tokens are no longer shared with angular apps
            if (this.tokenKey.startsWith('ngStorage-')) {
                return jwt.replace(/"/g, '');
            }
            return jwt;
        }
        catch (error) {
            return '';
        }
    }
    setToken(token) {
        let jwt = token;
        // add quotes so token can be shared with angular app, this can be removed
        // when tokens are no longer shared with angular apps
        if (this.tokenKey.startsWith('ngStorage-')) {
            jwt = `"${token}"`;
        }
        localStorage.setItem(this.tokenKey, jwt);
    }
    clearToken(msg) {
        this.log.debug(`Removing token : ${msg}`);
        localStorage.removeItem(this.tokenKey);
    }
    getImpersonationSubjectOrUser() {
        const content = this.getTokenContent();
        const { impersonationSubject, user } = (content === null || content === void 0 ? void 0 : content.payload) || {};
        return impersonationSubject || user;
    }
    getTokenContent() {
        try {
            return decode(this.getToken());
        }
        catch (error) {
            return null;
        }
    }
    isTokenExpired() {
        const token = this.getTokenContent();
        if (token && token.exp) {
            return token.exp < Date.now() / 1000;
        }
        return true;
    }
    signUrl(url) {
        const token = this.getToken();
        if (!token) {
            throw new Error('unable to sign url, no token');
        }
        const signedUrl = new URL(url);
        signedUrl.searchParams.set(TokenService.TOKEN_PARAM, token);
        return signedUrl.href;
    }
}
TokenService.TOKEN_PARAM = 'token';
//# sourceMappingURL=TokenService.js.map